/**
 * Currency helpers. The company's `currency` field determines what symbol
 * is used everywhere numbers are displayed. INR is the default.
 */

export const CURRENCIES = [
  { code: "INR", symbol: "₹", label: "Indian Rupee (₹)" },
  { code: "USD", symbol: "$", label: "US Dollar ($)" },
  { code: "EUR", symbol: "€", label: "Euro (€)" },
  { code: "GBP", symbol: "£", label: "British Pound (£)" },
  { code: "AED", symbol: "د.إ", label: "UAE Dirham (د.إ)" },
];

const SYMBOL = CURRENCIES.reduce((m, c) => { m[c.code] = c.symbol; return m; }, {});

export function symbolFor(code) {
  return SYMBOL[code] || "₹";
}

export function fmtMoney(amount, code = "INR") {
  const n = Number(amount || 0);
  const sym = symbolFor(code);
  // en-IN grouping renders as 1,00,000 which is expected in INR
  const locale = code === "INR" ? "en-IN" : "en-US";
  const formatted = new Intl.NumberFormat(locale, {
    maximumFractionDigits: 2,
    minimumFractionDigits: n % 1 === 0 ? 0 : 2,
  }).format(Math.abs(n));
  return `${n < 0 ? "-" : ""}${sym}${formatted}`;
}
